import React  from 'react';

import { ProductSearchHelper } from "../../helpers"
import { MultiSelect, Loading, Separator } from "../../components"
import { AllOptions, PriceRange } from "./index.jsx"
import { Radio, RadioGroup } from "../../components/ui"

// Price-filter sort choices → the (field, direction) pair onSortChange has always received.
const SORTS = {
    recommended: ['created_at', 'desc'],
    'price-asc': ['price', 'asc'],
    'price-desc': ['price', 'desc'],
}

// Same selection rules as the old radio dots: anything not sorted by price reads as Recommended.
const sortValue = (sort) => {
    if (sort?.field !== 'price') return 'recommended'
    if (sort?.direction === 'asc') return 'price-asc'
    if (sort?.direction === 'desc') return 'price-desc'
    return ''
}

const processOptions = (filter, options) => {
    if (['price'].includes(filter)) {
        const priceData = options && options[0] ? options[0] : null;
        
        if (priceData && 
            (priceData.min === null || priceData.max === null || 
             isNaN(priceData.min) || isNaN(priceData.max))) {
            console.warn('Invalid price range data received:', priceData);
            return { range: { min: 0, max: 100000 } };
        }
        
        return { range: priceData }
    }

    for (let i=0; i<options.length; i++) {
        if (options[i].id === null) {
            options[i].id = '-'
            options[i].name = '-'
        }
    }

    const popularOptions = options.slice(0, 8)

    options.sort(function(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
    });

    return { popularOptions, options }
}

const FilterOptions = ({
    filter,
    options : rawOptions,
    selections,
    sort,
    onChange,
    onSortChange
}) => {
    if (!rawOptions) {
        return (
            <div className="filters d-flex justify-content-center">
                <Loading type="loading" showText={false} className="align-self-center" />
            </div>
        )
    }

    const { options, popularOptions, range } = processOptions(filter, rawOptions)

    const onCheckboxChange = ({ target }, option) => {
        const newSelections = selections.filter((s) => s.id !== option.id)

        if (target.checked) {
            newSelections.push(option)
        }

        onChange(newSelections)
    }

    const onMultiSelectChange = (selections) => {
        selections = selections.map(s => options.find(o => o === s || (o.id && o.id === s)))
        onChange(selections)
    }

    const onRangeChange = (value) => {
        const valueStr = 'range:' + value[0] + '-' + value[1]

        onChange([{
            id: valueStr,
            name: valueStr
        }]);
    }

    const filterNamePlural = ProductSearchHelper.formatPluralFilterName(filter)
    const showAll = !['condition', 'price'].includes(filter)

    return (
        <div className="filters">
            { showAll && <h3 className="mt-0 mt-xl-3">Popular { filterNamePlural } </h3> }
            { !showAll && <h3 className="mt-0 mt-xl-3">{filterNamePlural}</h3> }

            { popularOptions && (
                <MultiSelect
                    defaultOptions={popularOptions}
                    onSelectionChange={onMultiSelectChange}
                    selections={[...selections]}
                />
            )}

            { range &&
                <>
                    <PriceRange {...range} onChange={onRangeChange} />

                    <Separator noMargin />

                    <RadioGroup
                        className="filter-sort mt-4 mb-4"
                        legend="Sort"
                        hideLegend
                        value={sortValue(sort)}
                        onChange={(value) => onSortChange(...SORTS[value])}
                    >
                        <Radio value="recommended" label="Recommended" />
                        <Radio value="price-asc" label="Lowest to highest price" />
                        <Radio value="price-desc" label="Highest to lowest price" />
                    </RadioGroup>
                </>
            }

            { showAll && (
                <>
                    <h3 className="mt-0 mt-xl-3">All { filterNamePlural }</h3>

                    <AllOptions
                        options={options}
                        selections={selections}
                        onOptionChange={onCheckboxChange}
                    />
                </>
            )}
        </div>
    )
}

export default FilterOptions
